import React from "react";
import { Typography, Tooltip } from "@mui/material";

const TextCapsule = (props) => {
  const {
    color,
    width,
    margin,
    minWidth,
    click,
    padding,
    border,
    borderRadius,
    fontSize,
    fontWeight,
    bgColor,
    hoverBgColor,
    title,
    textAlign,
    showTooltip,
  } = props;
  return (
    <Typography
      component="p"
      sx={{
        textAlign: textAlign ? textAlign : "left",
        color: color ? color : "color.dimGrey",
        padding: padding ? padding : "0.5rem 0.8rem",
        fontWeight: fontWeight ? fontWeight : "400",
        fontSize: fontSize ? fontSize : "0.78rem",
        border: border ? border : "none",
        borderRadius: borderRadius ? borderRadius : 10,
        margin: margin ? margin : "0.3rem",
        bgcolor: bgColor ? bgColor : "color.lightGrey",
        width: width ? width : "300px",
        minWidth: minWidth ? minWidth : "200px",
        cursor: "pointer",
        "&:hover": {
          bgcolor: hoverBgColor ? hoverBgColor : "color.magentaLight1",
          border: border ? border : "none",
        },
      }}
      onClick={click}
    >
      {showTooltip ? <>
        {title?.length > 10 ? (
          <Tooltip title={title}>
            <Typography>{title.slice(0, 10)}...</Typography>
          </Tooltip>
        ) : (
          <Typography>{title}</Typography>
        )}
      </>
        : <><Typography>{title}</Typography></>}
    </Typography>
  );
};

export default TextCapsule;
